/**
 * Category tree L1 and its sub-categories
 * It is Hard-coded for now in the order that appears in the category tree.
 * Category info should come from endpoint one day
 *
 * Fill in the missing categories as needed
 * */

import { CATEGORIES } from '@kijiji/category'

import { type SearchCategory } from '@/generated/graphql-types'

export const BUY_SELL_L1 = 10
export const BUY_SELL_L2 = [
  12, 274, 717, 108, 109, 26, 235, 111, 104, 253, 29659001, 110, 107, 139, 128, 19, 727, 133, 141,
  140, 132, 17, 29659003, 767, 16, 644, 103, 15093001, 17220001, 638, 14,
]
export const BUY_SELL_L3 = [
  689, 690, 691, 692, 693, 694, 695, 696, 697, 698, 699, 700, 701, 236, 237, 238, 239, 241, 242,
  243, 244, 245, 246, 247, 249, 250, 14970005, 14970006, 14970007, 14970001, 14970002, 14970003,
  14970004, 705, 715, 702, 703, 704, 652, 653, 654, 655, 656, 657, 658, 659, 660, 661, 662, 663,
  664, 665, 666, 667, 668, 669, 15093003, 15093002, 257, 258, 259, 260, 261, 262, 263, 264, 265,
  266, 267, 268, 269, 270, 271, 272, 273, 254, 255, 256, 29659002, 15, 769, 770, 771, 14922002,
  14922001, 768, 145, 29659005, 29659006, 29659004, 777, 778, 780, 781, 782, 783, 784, 785, 786,
  787, 788, 789, 790, 760, 761, 762, 765, 766, 645, 646, 647, 15096001, 648, 15096002, 649, 650,
  651, 14654001, 33035001, 619, 621, 622, 623, 14654002, 39730001, 624, 39730002, 625, 626, 627,
  792, 793, 721, 722, 723, 724, 725, 15058002, 15058001, 15058003, 718, 719, 720, 88888002, 772,
  773, 774, 776, 29324001, 610, 14922003, 611, 612, 613, 614, 615, 616, 617, 618, 15117001, 275,
  276, 277, 278, 279, 280, 281, 282, 283, 284, 285, 286, 287, 678, 726, 679, 680, 681, 682, 683,
  684, 685, 686, 687, 688, 737, 728, 729, 730, 731, 732, 733, 734, 735, 736,
]

export const CARS_VEHICLES_L1 = 27
export const CARS_VEHICLES_L2 = [33, 31, 301, 30, 29, 174, 172, 171, 142, 122]
export const CARS_VEHICLES_L3 = [
  311, 313, 315, 338, 333, 334, 335, 336, 327, 328, 329, 330, 332, 339, 340, 341, 343, 305, 306,
  307, 308, 310, 303, 304, 322, 323, 324, 325, 326, 321, 337, 309, 342, 312, 314, 331, 316, 317,
  318, 319, 320,
]
export const CARS_VEHICLES_CATEGORIES = {
  CARS_TRUCKS: 174,
  CLASSIC_CARS: 122,
  VEHICLE_PARTS: 31,
} as const

export const COMMUNITY_L1 = 1
export const COMMUNITY_L2 = [4, 5, 9, 2, 7, 289, 634, 3, 120, 15102001, 635, 636]
export const COMMUNITY_L3: number[] = []

export const JOBS_L1 = 45
export const JOBS_L2 = [
  50, 149, 148, 62, 47, 60, 46, 58, 898, 146, 61, 54, 147, 59, 150, 152, 55, 420,
]
export const JOBS_L3: number[] = []

export const PETS_L1 = 112
export const PETS_L2 = [
  114, 115, 125, 126, 127, 135, 143, 14654003, 14654004, 14654005, 14996001, 14996002, 14996003,
  217, 791,
]
export const PETS_L3: number[] = []

export const REAL_ESTATE_L1 = 34
export const REAL_ESTATE_L2 = [30349001, 170, 30353001]
export const REAL_ESTATE_L3 = [36, 37, 39, 40, 42, 641, 35, 643, 44]

export const SERVICES_L1 = 72
export const SERVICES_L2 = [
  76, 87, 160, 166, 169, 168, 84, 165, 15214001, 79, 86, 83, 144, 131, 302,
]
export const SERVICES_L3 = [
  1661, 1662, 738, 739, 740, 741, 742, 743, 744, 745, 746, 747, 748, 749, 750, 751, 752, 753, 754,
  755, 756, 757, 758, 759,
]

export const VACATION_RENTALS_L1 = 800
export const VACATION_RENTALS_L2 = [801, 802, 804, 805, 803]
export const VACATION_RENTALS_L3 = [
  806, 807, 808, 809, 810, 811, 812, 813, 814, 815, 816, 865, 866, 867, 868, 817, 818, 819, 820,
  821, 822, 823, 824, 825, 826, 827, 828, 829, 830, 831, 832, 833, 834, 835, 836, 837, 838, 839,
  840, 841, 842, 843, 844, 845, 846, 847, 848, 849, 850, 851, 852, 853, 854, 855, 856, 857, 858,
  859, 860, 861, 862, 863, 864, 869, 870, 871, 872, 873, 874, 875, 876, 877, 878, 879, 880, 881,
  882, 883, 884, 885, 886, 887, 888, 889, 890, 891, 892, 893, 894, 895, 896, 897,
]

export const VEHICLES_PART_ACCESSORIES_CATEGORIES = [
  31, 309, 312, 314, 316, 317, 318, 319, 320, 321, 331, 337, 342,
]

export const SKILL_TRADE_CATEGORIES = [
  76, 742, 738, 739, 740, 741, 742, 743, 757, 744, 745, 746, 747, 748, 749, 750, 759, 751, 752, 753,
  754, 755, 756, 757, 758,
]

export const FURNITURE_CATEGORY = 235

// Category Levels
const L1Categories = [
  BUY_SELL_L1,
  CARS_VEHICLES_L1,
  REAL_ESTATE_L1,
  JOBS_L1,
  SERVICES_L1,
  PETS_L1,
  COMMUNITY_L1,
  VACATION_RENTALS_L1,
]

const L2Categories = [
  ...BUY_SELL_L2,
  ...CARS_VEHICLES_L2,
  ...REAL_ESTATE_L2,
  ...JOBS_L2,
  ...SERVICES_L2,
  ...PETS_L2,
  ...COMMUNITY_L2,
  ...VACATION_RENTALS_L2,
]

/**
 * CHECK IF CATEGORY ID IS A PART OF A CERTAIN CATEGORY GROUP
 * If it is a L1 or L2, only category ID will get the correct category
 * For L3 we need the parentId to find the correct category
 * */
export const isAnyBuyAndSellCategory = (categoryId: number) =>
  [BUY_SELL_L1, ...BUY_SELL_L2, ...BUY_SELL_L3].includes(categoryId)

export const isAnyCarsVehiclesCategory = (categoryId: number) =>
  [CARS_VEHICLES_L1, ...CARS_VEHICLES_L2, ...CARS_VEHICLES_L3].includes(categoryId)

export const isAnyCommunityCategory = (categoryId: number) =>
  [COMMUNITY_L1, ...COMMUNITY_L2, ...COMMUNITY_L3].includes(categoryId)

export const isAnyJobsCategory = (categoryId: number) =>
  [JOBS_L1, ...JOBS_L2, ...JOBS_L3].includes(categoryId)

export const isAnyPetsCategory = (categoryId: number) =>
  [PETS_L1, ...PETS_L2, ...PETS_L3].includes(categoryId)

export const isAnyRealEstateCategory = (categoryId: number) =>
  [REAL_ESTATE_L1, ...REAL_ESTATE_L2, ...REAL_ESTATE_L3].includes(categoryId)

export const isAnyServicesCategory = (categoryId: number) => {
  /** Categories outside of Service node, but still "SERVICES" categories */
  const otherServices = [
    CATEGORIES.REAL_ESTATE_SERVICES_CATEGORY_ID,
    CATEGORIES.AUTOMOTIVE_SERVICES_CATEGORY_ID,
    CATEGORIES.ANIMAL_PET_SERVICES_CATEGORY_ID,
    CATEGORIES.CELL_PHONE_SERVICES_CATEGORY_ID,
  ]

  return [SERVICES_L1, ...SERVICES_L2, ...SERVICES_L3, ...otherServices].includes(categoryId)
}

export const isAnyVacationRentalsCategory = (categoryId: number) =>
  [VACATION_RENTALS_L1, ...VACATION_RENTALS_L2, ...VACATION_RENTALS_L3].includes(categoryId)

/** CHECK FOR SPECIFIC CATEGORIES */
export const isAutoPartsCategory = (categoryId: number) =>
  categoryId === CARS_VEHICLES_CATEGORIES.VEHICLE_PARTS
export const isAutomotiveServicesCategory = (categoryId: number) =>
  categoryId === CATEGORIES.AUTOMOTIVE_SERVICES_CATEGORY_ID
export const isAutosCategory = (categoryId: number) =>
  categoryId == CARS_VEHICLES_CATEGORIES.CARS_TRUCKS ||
  categoryId === CARS_VEHICLES_CATEGORIES.CLASSIC_CARS
export const isCarsTrucks = (categoryId: number) =>
  categoryId === CARS_VEHICLES_CATEGORIES.CARS_TRUCKS
export const isCarsVehiclesCategory = (categoryId: number) => categoryId === CARS_VEHICLES_L1
export const isBuyAndSellCategory = (categoryId: number) => categoryId === BUY_SELL_L1
export const isCommunityCategory = (categoryId: number) => categoryId === COMMUNITY_L1
export const isJobsCategory = (categoryId: number) => categoryId === JOBS_L1
export const isPetsCategory = (categoryId: number) => categoryId === PETS_L1
export const isRealEstateCategory = (categoryId: number) => categoryId === REAL_ESTATE_L1
export const isServicesCategory = (categoryId: number) => categoryId === SERVICES_L1
export const isVacationRentalsCategory = (categoryId: number) => categoryId === VACATION_RENTALS_L1

export const isCarsVehiclesExtendedRadiusCategory = (categoryId: number) => {
  if (isAutoPartsCategory(categoryId)) return false
  if (isAutomotiveServicesCategory(categoryId)) return false

  return [CARS_VEHICLES_L1, ...CARS_VEHICLES_L2, ...CARS_VEHICLES_L3].includes(categoryId)
}

export const isAnyFurnitureCategory = (category: SearchCategory) =>
  category.id === FURNITURE_CATEGORY || category.parentId === FURNITURE_CATEGORY

/** CHECK FOR CATEGORY LEVELS */
export const isL1Category = (categoryId: number) => L1Categories.includes(categoryId)

export const isL2Category = ({
  categoryId,
  parentId,
}: {
  categoryId?: number
  parentId?: number
}) =>
  parentId
    ? L1Categories.includes(parentId)
    : categoryId
    ? L2Categories.includes(categoryId)
    : false

export const isL3Category = (categoryId: number, parentId?: number) =>
  !isL1Category(categoryId) &&
  !isL2Category({ categoryId }) &&
  (!parentId || isL2Category({ categoryId: parentId }))
